import { PixelCrop } from 'react-image-crop';

import { canvasPreview } from './canvasPreview';

export async function imgPreview(image: HTMLImageElement, crop: PixelCrop) {
  let previewUrl: any = '';
  const canvas = document.createElement('canvas');
  await canvasPreview(image, canvas, crop);

  previewUrl = canvas.toDataURL();
  return previewUrl;
}
